function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { compute as t } from "compute-scroll-into-view";

var o = function o(t) {
  return !1 === t ? {
    block: "end",
    inline: "nearest"
  } : function (t) {
    return t === Object(t) && 0 !== Object.keys(t).length;
  }(t) ? t : {
    block: "start",
    inline: "nearest"
  };
};

function e(e, r) {
  if (!e.isConnected || !function (t) {
    var o = t;

    for (; o && o.parentNode;) {
      if (o.parentNode === document) return !0;
      o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
    }

    return !1;
  }(e)) return;

  var n = function (t) {
    var o = window.getComputedStyle(t);
    return {
      top: parseFloat(o.scrollMarginTop) || 0,
      right: parseFloat(o.scrollMarginRight) || 0,
      bottom: parseFloat(o.scrollMarginBottom) || 0,
      left: parseFloat(o.scrollMarginLeft) || 0
    };
  }(e);

  if (function (t) {
    return "object" == _typeof(t) && "function" == typeof t.behavior;
  }(r)) return r.behavior(t(e, r));
  var l = "boolean" == typeof r || null == r ? void 0 : r.behavior;

  var _iterator = _createForOfIteratorHelper(t(e, o(r))),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          a = _step$value.el,
          i = _step$value.top,
          s = _step$value.left;

      var _t = i - n.top + n.bottom,
          _o = s - n.left + n.right;

      a.scroll({
        top: _t,
        left: _o,
        behavior: l
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export { e as default };